module.exports = __webpack_public_path__ + "assets/img/3019.da56b28f.png";